export default {"src":"/_next/static/media/close.a176b4ce.svg","height":28,"width":27,"blurWidth":0,"blurHeight":0};